import * as yup from 'yup';

export const SystemAccessSchema = yup.object({
  roleId: yup.string().notRequired().nullable(),
  initials: yup.string().notRequired().nullable(),
  username: yup.string().required().min(5, 'User name requires at least 5 letters'),
});

export const SystemAccessTimeosSchema = yup.object({
  roleId: yup.string().notRequired().nullable(),
  initials: yup.string().notRequired().nullable(),
  username: yup.string().required().min(5, 'User name requires at least 5 letters'),
});

export interface ISystemAccess {
  roleId?: string;
  initials?: string;
  username: string;
}
